
app.main.init();